const getAllReactDescendents = (elem) => {
  var i, oneChild, result;
  result = [];
  if (!elem) {
  } else if (!elem.props || !elem.props.children || !elem.props.children.length) {
    result.push(elem);
  } else {
    result.push(elem);
    for (i = 0; i < elem.props.children.length; i++) {
      oneChild = elem.props.children[i];
      result = result.concat(getAllReactDescendents(oneChild));
    }
  }
  return result;
};

export default getAllReactDescendents;